export default __webpack_public_path__ + "static/screenshot_desert-b3477b60843e2316c113d7bbb258ad13.png";